import WifiOffIcon from '@material-ui/icons/WifiOff';

import { useTLang } from '../../../../../intl/intl';
import makeClasses from './OfflineBanner.styles';
import { useOfflineBanner } from './hooks';

export function OfflineBanner() {
  const _classes = makeClasses();
  const { isOffline } = useOfflineBanner();
  const bannerText = useTLang({
    id: 'offline.banner.message',
  });

  if (!isOffline) {
    return null;
  }

  return (
    <div className={_classes.notification}>
      <WifiOffIcon className={_classes.icon} />
      <span className={_classes.notificationText}>{bannerText}</span>
    </div>
  );
}
